




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import util from '@/common/util'
@Component({
  components: {
  }
})
export default class CouponItem extends Vue {
  @Prop(Boolean) readonly visible!: boolean
  @Prop(Object) readonly info!: { 'created_at': string, 'expires_in': number, 'qr_code': string, title: string, id: number }

  codeUrl = ''

  get endDate() {
    return util.formatTime(new Date(+new Date(this.info.created_at) + this.info.expires_in * 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
  }

  handleClose() {
    this.$emit('update:visible', false)
  }

  @Watch('visible')
  async onToggle(val: boolean) {
    if (val) {
      const { code, data, message } = await this.$rest.coupon.getQRCode(this.info.id)()
      if (code === 0) {
        this.codeUrl = data.qrcode_url
      }
    }
  }
}
